import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-zinc-800 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/c396747a877dd1d0cb2c362594545533/02f73f35a156274691f368b3b9fff544.png"
              alt="IND Mobility"
              width="40"
              height="40"
              className="h-10 w-auto mb-6"
            />
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/ind_echairs/" target="_blank" rel="nofollow noreferrer" aria-label="IND Mobility on Instagram" className="w-10 h-10 flex items-center justify-center bg-zinc-900 rounded-full hover:bg-teal-500 hover:text-black transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>

            </div>
          </div>

          <div>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; 2026 IND Mobility. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?ref=logo" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
